<template>
  <div class="correction-page">
    <div class="correction-card">
      <div class="correction-card-title"><i class="fas fa-edit mr-2"></i>打刻修正</div>
      <div class="time-buttons">
        <button class="time-btn" @click="showTimeEdit('start')">
          <span class="time-btn-label">スタート</span>
          <span class="time-btn-value">{{ time_start_hours }}<small>:</small>{{ time_start_minutes }}</span>
        </button>
        <button class="time-btn" @click="showTimeEdit('stop')">
          <span class="time-btn-label">ストップ</span>
          <span class="time-btn-value">{{ time_stop_hours }}<small>:</small>{{ time_stop_minutes }}</span>
        </button>
        <button class="time-btn" @click="showTimeEdit('break')">
          <span class="time-btn-label">休憩</span>
          <span class="time-btn-value">{{ basic_break_hours }}<small>:</small>{{ basic_break_minutes }}</span>
        </button>
      </div>

      <!-- Summary -->
      <div class="summary-box">
        <div class="summary-row">
          <span class="summary-label">勤務時間</span>
          <span class="summary-value">{{ working_hours }}<small>:</small>{{ working_minutes }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">休憩時間</span>
          <span class="summary-value">{{ basic_break_hours }}<small>:</small>{{ basic_break_minutes }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">残業時間</span>
          <span class="summary-value">{{ overtime_hours }}<small>:</small>{{ overtime_minutes }}</span>
        </div>
      </div>

      <!-- Comment -->
      <div class="comment-box">
        <label class="comment-label">{{ isEditing ? 'コメント（必須）' : 'コメント' }}</label>
        <textarea class="comment-input" v-model="notes" :placeholder="isEditing ? '修正理由を入力してください' : 'コメント'" rows="2"></textarea>
      </div>

      <!-- Buttons -->
      <div class="action-buttons">
        <!-- 承認済み: 修正申請ボタン表示 -->
        <button v-if="!isEditing && timecard.approval_status === 2" class="btn-action btn-edit" @click="isEditing = true">
          <i class="fas fa-edit mr-1"></i>修正申請
        </button>
        <!-- 修正モード or 修正依頼/承認待ち/新規: 申請ボタン -->
        <button v-if="isEditing || timecard.approval_status === 3 || timecard.approval_status === 1 || !timecard.approval_status" class="btn-action btn-apply" @click="updateTimecard" :disabled="isLoading">
          <span v-if="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          <span v-else>申 請</span>
        </button>
        <!-- 修正モードのキャンセル -->
        <button v-if="isEditing" class="btn-action btn-cancel" @click="isEditing = false; notes = ''">
          キャンセル
        </button>
        <button class="btn-action btn-delete" @click="deleteTimecard" :disabled="isLoading">
          <span v-if="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
          <span v-else>削 除</span>
        </button>
      </div>
    </div>

    <!-- Time edit modal (Vue-managed) -->
    <div v-if="showPicker" class="modal-overlay" @click.self="showPicker = false">
      <div class="picker-box">
        <div class="picker-header">
          <h6 class="picker-title">{{ timePicker.label }}</h6>
          <button class="picker-close" @click="showPicker = false">&times;</button>
        </div>
        <div class="picker-body">
          <div class="preset-btns">
            <button class="preset-btn" @click="setSelectedTime(regular_start_hours, regular_start_minutes)">
              {{ regular_start_hours }}:{{ regular_start_minutes }}
            </button>
            <button class="preset-btn" @click="setSelectedTime(regular_stop_hours, regular_stop_minutes)">
              {{ regular_stop_hours }}:{{ regular_stop_minutes }}
            </button>
          </div>
          <div class="picker-selects">
            <select class="picker-select" v-model="timePicker.hour">
              <option v-for="h in hourValue" :key="h" :value="h">{{ h.toString().padStart(2, '0') }}</option>
            </select>
            <span class="picker-sep">:</span>
            <select class="picker-select" v-model="timePicker.minute">
              <option v-for="m in minuteValue" :key="m" :value="m">{{ m.toString().padStart(2, '0') }}</option>
            </select>
          </div>
        </div>
        <div class="picker-footer">
          <button class="btn-confirm" @click="timeConfirm">確 定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isLoading: false,
      showPicker: false,
      isEditing: false,
      notes: '',
      basic_break_hours_setting: null,
      timecard: {
        id: null, date: null, time_start: null, time_stop: null,
        basic_break_hours: null, overtime_hours: null, working_hours: null,
        regular_working_hours_start: null, regular_working_hours_stop: null,
        approval_status: null, staff_id: null,
      },
      timePicker: { hour: 0, minute: 0, label: 'スタート' },
      timeType: null,
      hourValue: [],
      minuteValue: [],
    }
  },
  beforeMount() {
    this.parseAndValidateTimecardParam();
    for (let i = 0; i <= 23; i++) this.hourValue.push(i);
    for (let i = 0; i <= 59; i++) this.minuteValue.push(i);
  },
  computed: {
    time_start_hours() { return this.timecard.time_start ? this.timecard.time_start.hours().toString().padStart(2, '0') : '--'; },
    time_start_minutes() { return this.timecard.time_start ? this.timecard.time_start.minutes().toString().padStart(2, '0') : '--'; },
    time_stop_hours() { return this.timecard.time_stop ? this.timecard.time_stop.hours().toString().padStart(2, '0') : '--'; },
    time_stop_minutes() { return this.timecard.time_stop ? this.timecard.time_stop.minutes().toString().padStart(2, '0') : '--'; },
    isPunchedTimeStart() { return this.timecard.time_start != null; },
    isPunchedTimeStop() { return this.timecard.time_stop != null; },
    working_hours() { return this.timecard.working_hours ? this.timecard.working_hours.hours().toString().padStart(2, '0') : '00'; },
    working_minutes() { return this.timecard.working_hours ? this.timecard.working_hours.minutes().toString().padStart(2, '0') : '00'; },
    basic_break_hours() { return this.timecard.basic_break_hours ? this.timecard.basic_break_hours.hours().toString().padStart(2, '0') : '00'; },
    basic_break_minutes() { return this.timecard.basic_break_hours ? this.timecard.basic_break_hours.minutes().toString().padStart(2, '0') : '00'; },
    overtime_hours() { return this.timecard.overtime_hours ? this.timecard.overtime_hours.hours().toString().padStart(2, '0') : '00'; },
    overtime_minutes() { return this.timecard.overtime_hours ? this.timecard.overtime_hours.minutes().toString().padStart(2, '0') : '00'; },
    regular_start_hours() { return this.timecard.regular_working_hours_start ? this.timecard.regular_working_hours_start.hours().toString().padStart(2, '0') : '00'; },
    regular_start_minutes() { return this.timecard.regular_working_hours_start ? this.timecard.regular_working_hours_start.minutes().toString().padStart(2, '0') : '00'; },
    regular_stop_hours() { return this.timecard.regular_working_hours_stop ? this.timecard.regular_working_hours_stop.hours().toString().padStart(2, '0') : '00'; },
    regular_stop_minutes() { return this.timecard.regular_working_hours_stop ? this.timecard.regular_working_hours_stop.minutes().toString().padStart(2, '0') : '00'; },
  },
  watch: {
    'timecard.time_start'() { this.calculateTimecard(); },
    'timecard.time_stop'() { this.calculateTimecard(); },
    'timecard.basic_break_hours'() { this.calculateTimecard(); },
  },
  methods: {
    setSelectedTime(hour, minute) {
      this.timePicker.hour = parseInt(hour);
      this.timePicker.minute = parseInt(minute);
    },
    timeConfirm() {
      this.showPicker = false;
      const hh = (this.timePicker.hour || 0).toString().padStart(2, '0');
      const mm = (this.timePicker.minute || 0).toString().padStart(2, '0');
      const val = this.$moment(`${this.timecard.date} ${hh}:${mm}:00`);
      if (this.timeType === 'start') this.timecard.time_start = val;
      else if (this.timeType === 'stop') this.timecard.time_stop = val;
      else if (this.timeType === 'break') this.timecard.basic_break_hours = val;
      this.timeType = null;
    },
    showTimeEdit(type) {
      this.timeType = type;
      if (type === 'start') {
        this.timePicker.hour = this.time_start_hours !== '--' ? parseInt(this.time_start_hours) : 0;
        this.timePicker.minute = this.time_start_minutes !== '--' ? parseInt(this.time_start_minutes) : 0;
        this.timePicker.label = 'スタート';
      } else if (type === 'stop') {
        this.timePicker.hour = this.time_stop_hours !== '--' ? parseInt(this.time_stop_hours) : 0;
        this.timePicker.minute = this.time_stop_minutes !== '--' ? parseInt(this.time_stop_minutes) : 0;
        this.timePicker.label = 'ストップ';
      } else {
        this.timePicker.hour = parseInt(this.basic_break_hours) || 0;
        this.timePicker.minute = parseInt(this.basic_break_minutes) || 0;
        this.timePicker.label = '休憩';
      }
      this.showPicker = true;
    },
    parseAndValidateTimecardParam() {
      try {
        const timecard = JSON.parse(decodeURIComponent(this.$route.params.timecard));
        this.setTimecard(timecard);
      } catch (e) { console.log(e); }
    },
    setTimecard(tc) {
      this.timecard.date = tc.time_start ? this.$moment(tc.time_start).format('YYYY-MM-DD') : this.$moment(tc.date).format('YYYY-MM-DD');
      this.timecard.id = tc.id;
      this.timecard.staff_id = tc.staff_id || null;
      this.timecard.time_start = tc.time_start ? this.$moment(tc.time_start) : null;
      this.timecard.time_stop = tc.time_stop ? this.$moment(tc.time_stop) : null;
      this.timecard.working_hours = this.timecard.time_start ? this.$moment(`${this.timecard.date} 00:00`) : null;
      if (this.isPunchedTimeStart && this.isPunchedTimeStop && !this.timecard.working_hours) {
        this.timecard.working_hours = this.$moment(`${this.timecard.date} ${tc.working_hours}:00`);
      }
      this.timecard.basic_break_hours = tc.basic_break_hours !== '00:00' ? this.$moment(`${this.timecard.date} ${tc.basic_break_hours}`) : null;
      this.basic_break_hours_setting = tc.basic_break_hours !== '00:00' ? this.$moment(`${this.timecard.date} ${tc.basic_break_hours}`) : null;
      this.timecard.overtime_hours = tc.overtime_hours ? this.$moment(`${this.timecard.date} ${tc.overtime_hours}:00`) : null;
      this.timecard.regular_working_hours_start = tc.regular_working_hours_start ? this.$moment(`${this.timecard.date} ${tc.regular_working_hours_start}`) : null;
      this.timecard.regular_working_hours_stop = tc.regular_working_hours_stop ? this.$moment(`${this.timecard.date} ${tc.regular_working_hours_stop}`) : null;
      this.timecard.approval_status = tc.approval_status;
    },
    calculateTimecard() {
      if (!this.timecard.regular_working_hours_stop || !this.timecard.regular_working_hours_start) return;
      let regularDuration = this.$moment.duration(this.timecard.regular_working_hours_stop.diff(this.timecard.regular_working_hours_start));
      if (this.timecard.basic_break_hours) {
        regularDuration.subtract(this.timecard.basic_break_hours.hours(), 'hours').subtract(this.timecard.basic_break_hours.minutes(), 'minutes');
      }
      if (this.timecard.time_stop) {
        if (this.timecard.time_stop.isBefore(this.timecard.time_start)) {
          this.timecard.time_stop = this.timecard.time_stop.add(1, 'days');
        }
        let worked = this.$moment.duration(this.timecard.time_stop.diff(this.timecard.time_start));
        worked = worked.subtract(parseInt(this.basic_break_hours), 'hours').subtract(parseInt(this.basic_break_minutes), 'minutes');
        this.timecard.working_hours = worked;
        let ot = this.$moment.duration(0);
        if (worked.asMinutes() > regularDuration.asMinutes()) {
          ot = worked.clone().subtract(regularDuration);
        }
        this.timecard.overtime_hours = ot;
      }
    },
    async updateTimecard() {
      // コメント必須
      if (!this.notes.trim()) {
        this.$toast.error('コメントを入力してください');
        return;
      }
      try {
        this.isLoading = true;
        const payload = {
          time_start: this.timecard.time_start.format('YYYY-MM-DD HH:mm:ss'),
          time_stop: this.timecard.time_stop.format('YYYY-MM-DD HH:mm:ss'),
          break_time: `${this.basic_break_hours}:${this.basic_break_minutes}`,
          staff_id: this.timecard.staff_id,
        };
        if (this.notes.trim()) {
          payload.notes = this.notes.trim();
        }
        await this.$http.put(
          process.env.VUE_APP_API_PATH + `/staff/shop/${this.$store.getters.shop}/timecard/apply/${this.timecard.id}`,
          payload
        );
        this.$router.go(-1);
      } catch (e) { console.log(e); }
      this.isLoading = false;
    },
    async deleteTimecard() {
      try {
        this.isLoading = true;
        await this.$http.delete(process.env.VUE_APP_API_PATH + `/staff/shop/${this.$store.getters.shop}/timecard/${this.timecard.id}`);
        this.$router.go(-1);
      } catch (e) { console.log(e); }
      this.isLoading = false;
    },
  }
}
</script>

<style>
.correction-page {
  display: flex;
  justify-content: center;
  width: 100%;
}

.correction-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  padding: 24px 20px;
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;
}

.correction-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #049C4C;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;
  display: block;
  width: 100%;
}

/* Time buttons */
.correction-card .time-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 24px;
}

.correction-card .time-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-radius: 12px;
  border: 2px solid #049C4C;
  background: #fff;
  cursor: pointer;
  transition: all 0.15s;
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.correction-card .time-btn:hover { background: #f0fff4; }

.correction-card .time-btn-label {
  font-size: 15px;
  font-weight: 600;
  color: #2d3748;
}

.correction-card .time-btn-value {
  font-size: 22px;
  font-weight: 700;
  color: #049C4C;
  font-variant-numeric: tabular-nums;
  display: flex;
  align-items: baseline;
}

.correction-card .time-btn-value small {
  font-size: 18px;
  color: #a0aec0;
  margin: 0 1px;
}

/* Summary */
.correction-card .summary-box {
  background: #f7fafc;
  border-radius: 12px;
  padding: 16px 20px;
  border: 1px solid #e2e8f0;
  margin-bottom: 24px;
}

.correction-card .summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.correction-card .summary-row + .summary-row {
  border-top: 1px solid #edf2f7;
}

.correction-card .summary-label {
  font-size: 15px;
  color: #4a5568;
  font-weight: 500;
}

.correction-card .summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #1a202c;
  font-variant-numeric: tabular-nums;
}

.correction-card .summary-value small {
  font-size: 16px;
  color: #a0aec0;
}

/* Action buttons */
.correction-card .action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.correction-card .btn-action {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  height: auto;
}

/* Comment box */
.correction-card .comment-box {
  margin-bottom: 20px;
}

.correction-card .comment-label {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 4px;
  display: block;
}

.correction-card .comment-input {
  width: 100%;
  border: 1.5px solid #d2d6dc;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.2s;
}

.correction-card .comment-input:focus {
  border-color: #049C4C;
  outline: none;
  box-shadow: 0 0 0 3px rgba(4, 156, 76, 0.12);
}

.correction-card .btn-apply { background: #4075FF; color: #fff; }
.correction-card .btn-apply:hover { background: #2d5fdf; }
.correction-card .btn-edit { background: #049C4C; color: #fff; }
.correction-card .btn-edit:hover { background: #038a42; }
.correction-card .btn-cancel { background: #fff; color: #718096; border: 1.5px solid #d2d6dc; }
.correction-card .btn-cancel:hover { background: #f7fafc; }
.correction-card .btn-delete { background: #fff; color: #e53e3e; border: 2px solid #e53e3e; }
.correction-card .btn-delete:hover { background: #fff5f5; }

/* Picker modal */
.correction-page .modal-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4); z-index: 1050;
  display: flex; align-items: center; justify-content: center;
}

.picker-box {
  background: #fff; border-radius: 16px; width: 320px; max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2); overflow: hidden;
}

.picker-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border-bottom: 1px solid #edf2f7;
}

.picker-title { font-weight: 700; font-size: 16px; margin: 0; }

.picker-close {
  border: none; background: none; font-size: 24px; color: #718096; cursor: pointer;
}

.picker-body { padding: 20px; }

.picker-box .preset-btns {
  display: flex; gap: 10px; margin-bottom: 20px;
}

.picker-box .preset-btn {
  flex: 1; padding: 10px; border: 1.5px solid #d2d6dc; border-radius: 8px;
  background: #f7fafc; font-size: 16px; font-weight: 600; color: #4a5568;
  cursor: pointer; text-align: center; transition: all 0.15s;
  height: auto; width: auto;
}

.picker-box .preset-btn:hover { border-color: #049C4C; color: #049C4C; }

.picker-selects {
  display: flex; align-items: center; justify-content: center; gap: 8px;
}

.picker-select {
  font-size: 24px; font-weight: 700; padding: 10px 16px;
  border: 2px solid #d2d6dc; border-radius: 10px; text-align: center;
  width: 100px; -webkit-appearance: none; appearance: none; background: #fff;
}

.picker-select:focus { border-color: #049C4C; outline: none; }

.picker-sep { font-size: 28px; font-weight: 700; color: #a0aec0; }

.picker-footer { padding: 16px 20px; border-top: 1px solid #edf2f7; }

.picker-box .btn-confirm {
  width: 100%; padding: 12px; background: #049C4C; color: #fff;
  border: none; border-radius: 10px; font-size: 16px; font-weight: 600;
  cursor: pointer; transition: all 0.15s; height: auto;
}

.picker-box .btn-confirm:hover { background: #038a42; }
</style>
